import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import { fetchQuery } from "./../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import { services } from "./jobConstant";
import { deptmentList } from "./jobRegisterConst";
import { getPermissions } from "../rbac/hasAccess";
import moment from "moment";

const headers = [
  "id",
  "jobNumber",
  "jobDate",
  "clientName",
  "address",
  "workOrderNo",
  "projectOwner",
  "projectInCharge",
  "siteName",
  "service",
  "inclusionsHRComplaince",
  // "inclusionsWorkmenCompensationPolicy",
  // "inclusionsTPI",
];

const fields = [
  { value: "jobNumber", label: "Job Number" },
  { value: "clientName", label: "Client Name" },
  { value: "service", label: "Service" },
  { value: "projectInCharge", label: "Project In Charge" },
  { value: "siteName", label: "Site Name" },
  { value: "department", label: "Department" },
];

const JobRegisterList = (props) => {
  const navigate = useNavigate();
   const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/editJobRegister/${row.id}`);
  const handleEditView = (row) => navigate(`/editJobRegisterView/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("jobRegister", row.id);

  const [jobRegisterList, setJobRegisterList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "jobNumber");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [selectedIds, setSelectedIds] = useState([]);
  const [allJobsData, setAllJobsData] = useState([]);

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  // Updated function to handle services
  const formatServices = (serviceIds) => {
    const ids = serviceIds.split(",").map((id) => parseInt(id));
    const selectedServices = services.filter((service) =>
      ids.includes(service.id)
    );
    // If only one service is selected, show the name
    if (selectedServices.length === 1) {
      return selectedServices[0].label;
    }
    // If multiple services are selected, show the name of the first service and the count of additional services
    return selectedServices.length > 0
      ? `${selectedServices[0].label} +${selectedServices.length - 1}`
      : "";
  };
  const formatDepartment = (departmentIds) => {
    const ids = departmentIds.split(",").map((id) => parseInt(id));
    const selectedDepartments = deptmentList.filter((dept) =>
      ids.includes(dept.id)
    );
    // If only one department is selected, show the name
    if (selectedDepartments.length === 1) {
      return selectedDepartments[0].label;
    }
    // If multiple departments are selected, show the name of the first department and the count of additional departments
    return selectedDepartments.length > 0
      ? `${selectedDepartments[0].label} +${selectedDepartments.length - 1}`
      : "";
  };

  // WHERE clause builder
  const getWhereClause = () => {
    const key = searchKey?.trim().toLowerCase();

    let whereConditions = ["jobRegister.status = 1"]; // always active

    const colMap = {
      jobNumber: "jobRegister.jobNumber",
      workOrderAmount: "jobRegister.workOrderAmount",
      clientName: "jobRegister.clientName",
      siteName: "jobRegister.siteName",
    };

    //  Project In-Charge search
    if (searchBy === "projectInCharge" && key) {
      whereConditions.push(`LOWER(incharge.name) LIKE '%${key}%'`);
    }

    if (searchBy === "service" && key) {
      const serviceMatchIds = services
        .filter((s) => s.label.toLowerCase().includes(key))
        .map((s) => s.id.toString());

      if (serviceMatchIds.length) {
        whereConditions.push(
          `(${serviceMatchIds
            .map((id) => `FIND_IN_SET('${id}', jobRegister.serviceId)`)
            .join(" OR ")})`
        );
      }
    }
    if (searchBy === "department" && key) {
      const departmentMatchIds = deptmentList
        .filter((d) => d.label.toLowerCase().includes(key))
        .map((d) => d.id.toString());
      if (departmentMatchIds.length) {
        whereConditions.push(
          `(${departmentMatchIds
            .map((id) => `FIND_IN_SET('${id}', jobRegister.department)`)
            .join(" OR ")})`
        );
      }
    }
    // Normal column search
    if (colMap[searchBy] && key) {
      whereConditions.push(`LOWER(${colMap[searchBy]}) LIKE '%${key}%'`);
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  // DATA query
  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)
        }`;
    }

    return `SELECT jobRegister.*, projectOwner.name AS projectOwner, incharge.name AS projectInCharge FROM jobRegister LEFT JOIN employees AS projectOwner ON projectOwner.id = jobRegister.projectOwnerId LEFT JOIN employees AS incharge ON incharge.id = jobRegister.projectInchargeId ${whereClause} ORDER BY jobRegister.id DESC ${paginationSettings};`;
  };

  // COUNT query
  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(*) AS totalRows FROM jobRegister LEFT JOIN employees AS incharge ON incharge.id = jobRegister.projectInchargeId ${whereClause};`;
  };

  // Fetch data
  const fetchData = async () => {
    try {
      const allDataQuery = fetchAllJobsData();
      const [jobData, countResult, allJobsData] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
        fetchQuery(allDataQuery)
      ]);
        const modifiedAllJobsData = allJobsData.map((item) => ({
          ...item,
          service: item.serviceId ? formatServices(item.serviceId) : "",
          department: item.department ? formatDepartment(item.department) : "",
          inclusionsHRComplaince: item.inclusionsHRComplaince ? "Yes" : "No",
          jobDate: item.jobDate ? moment(item.jobDate).format("DD-MM-YYYY") : "",
        }));

      const modifiedData = jobData.map((item) => ({
        ...item,
        service: item.serviceId ? formatServices(item.serviceId) : "",
        department: item.department ? formatDepartment(item.department) : "",
        inclusionsHRComplaince: item.inclusionsHRComplaince ? "Yes" : "No",
        inclusionsWorkmenCompensationPolicy:
          item.inclusionsWorkmenCompensationPolicy ? "Yes" : "No",
        inclusionsTPI: item.inclusionsTPI ? "Yes" : "No",
      }));

      setJobRegisterList(modifiedData);
      setTotalRecords(countResult?.[0]?.totalRows || 0);
      setAllJobsData(modifiedAllJobsData);
    } catch (error) {
      console.error("Error fetching job register data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("jobNumber");
    setSearchKey("");
    // Clear all job register list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  const handleSelectRow = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];
    setSelectedIds(updated);
  };

  const handleSelectAll = () => {
    if (selectedIds.length === jobRegisterList.length) {
      setSelectedIds([]);
    } else {
      const allIds = jobRegisterList.map((row) => row.id);
      setSelectedIds(allIds);
    }
  };

  const handleMultipleDelete = () => {
    submitSiteDelete("jobRegister", selectedIds);
  };

  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      handlePaginationChange(newPage, rowsPerPage);
      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    const newRows = parseInt(e.target.value, 10);
    handlePaginationChange(0, newRows);
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const fetchAllJobsData = () => {
    const whereClause = getWhereClause();
      return `SELECT jobRegister.*, projectOwner.name AS projectOwner, incharge.name AS projectInCharge FROM jobRegister LEFT JOIN employees AS projectOwner ON projectOwner.id = jobRegister.projectOwnerId LEFT JOIN employees AS incharge ON incharge.id = jobRegister.projectInchargeId ${whereClause} ORDER BY jobRegister.id DESC`;
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/editJobRegister/0"
          label="Add Job Register"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Job Register"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        showExcelDownload={permissions.excelDownload || permissions.allAccess}
        setSearched={setSearched}
        finalData={allJobsData}
        notNeededColumn={["id","clientInitials","workOrderNo","workOrderPdf","reference","contactPerson","ContactNo","panNo","gstNumber","principleClient","projectHodId","projectInchargeId","workOrderAmount","workOrderValidity","inclusionsWorkmenCompensationPolicy","inclusionsTPI","country","siteState","siteCity","projectOwnerId","serviceId","billingClientName","billingAddress","billingpanNo","billinggstNumber","billingcontactPerson","billingContactNo","workmen_comp_policy","workmen_comp_policy_start","workmen_comp_policy_end","workmen_comp_document","insurance_policy","insurance_policy_start","insurance_policy_end","insurance_document","pbg_policy","pbg_policy_start","pbg_policy_end","pbg_document","bg_policy","bg_policy_start","bg_policy_end","bg_document","retention","retention_percentage","labour_license_document","car_policy","car_policy_start","car_policy_end","car_policy_document","emd","emd_amount","emd_description","emd_document","dlp_period_description","labour_license","dlp","workmen_comp_policy_number","insurance_policy_number","pbg_amount","bg_amount","car_policy_number","createdby","status", "projectName"]}
      />

      {/* Multiple Delete Button */}
      {selectedIds.length > 0 && (permissions.delete || permissions.allAccess) && (
        <div className="shadow-sm p-2 pt-1 mb-2 bg-white">
          <button
            onClick={handleMultipleDelete}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      )}

      {/* Static Table */}
      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                <th className="px-2 py-3 text-center">
                  <input
                    type="checkbox"
                    checked={selectedIds.length === jobRegisterList.length && jobRegisterList.length > 0}
                    onChange={handleSelectAll}
                  />
                </th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Job Number</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Job Date</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Client Name</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Address</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Project Owner</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Project In Charge</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Site Name</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Service</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">HR Compliance</th>
                <th className="px-4 py-3 text-center whitespace-nowrap">Department</th>
                {(permissions.edit || permissions.view || permissions.delete || permissions.allAccess) && (
                  <th className="px-4 py-3 text-center whitespace-nowrap">Actions</th>
                )}
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {jobRegisterList.map((row, index) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  <td className="px-2 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </td>
                  <td className="px-4 py-3 text-center">
                    {currentPage * rowsPerPage + index + 1}
                  </td>
                  <td className="px-4 py-3 text-center">{row.jobNumber}</td>
                  <td className="px-4 py-3 text-center">
                    {row.jobDate ? moment(row.jobDate).format("DD-MM-YYYY") : ""}
                  </td>
                  <td className="px-4 py-3 text-center truncate-text">{row.clientName}</td>
                  <td className="px-4 py-3 text-center truncate-text">{row.address}</td>
                  <td className="px-4 py-3 text-center">{row.projectOwner}</td>
                  <td className="px-4 py-3 text-center">{row.projectInCharge}</td>
                  <td className="px-4 py-3 text-center">{row.siteName}</td>
                  <td className="px-4 py-3 text-center">{row.service}</td>
                  <td className="px-4 py-3 text-center">{row.inclusionsHRComplaince}</td>
                  <td className="px-4 py-3 text-center">{row.department}</td>
                  {(permissions.edit || permissions.view || permissions.delete || permissions.allAccess) && (
                    <td className="px-4 py-2 text-center whitespace-nowrap">
                      <div className="flex items-center justify-center gap-2">
                        {(permissions.edit || permissions.allAccess) && (
                          <button
                            onClick={() => handleEdit(row)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <EditIcon fontSize="small" />
                          </button>
                        )}
                        {(permissions.view || permissions.allAccess) && (
                          <button
                            onClick={() => handleEditView(row)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <VisibilityIcon fontSize="small" />
                          </button>
                        )}
                        {(permissions.delete || permissions.allAccess) && (
                          <button
                            onClick={() => handleDelete(row)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <DeleteIcon fontSize="small" />
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))}

              {jobRegisterList.length === 0 && (
                <tr>
                  <td colSpan="12" className="text-center py-4 text-gray-500">
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between gap-2 px-2 py-2 bg-blue-50 text-xs sm:text-sm border-t overflow-x-auto whitespace-nowrap">
          <div className="flex items-center gap-1">
            <span>Rows Per Page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-1 py-0.5 text-xs sm:text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <span className="text-gray-600 hidden sm:inline">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRecords
                )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobRegisterList;